import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { StoreService } from '../store.service';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class ReferralStatusGuard implements CanActivate {

  constructor(private svc: StoreService, private router: Router) { };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const bearer = localStorage.getItem('bearer') ?? '';

    let token = '';

    if (bearer.length > 0) {
      token = bearer.toString();
    }

    return new Promise((resolve, reject) => {
      this.svc.getReferralStatus(token).toPromise().then((response) => {
        if (response['data']['status'] === true) {
          resolve(true);
        } else {
          this.router.navigate(['dashboard/overview']);
          resolve(false);
        }
      });
    });
  }
}
